import { useEffect } from 'react';

import './spotify-theme.css';

export function useBUITheme(themeMode: 'dark' | 'light' = 'dark') {
  useEffect(() => {
    document.body.setAttribute('data-theme-mode', themeMode);
    document.body.setAttribute('data-theme-name', 'spotify');
    return () => {
      document.body.removeAttribute('data-theme-mode');
      document.body.removeAttribute('data-theme-name');
    };
  }, [themeMode]);
}
